import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Hi, I'm Wilson Maifeld!`}</h2>
    <p>{`I can take care of those land mines that cover your back yard!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      